import React from 'react';
import cx from 'classnames';
import GridRow from '@athena/spark/GridRow';
import GridCol from '@athena/spark/GridCol';
import styles from './Container.module.scss';

const Container: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ children, className }) => {
  return (
    <GridRow removeGuttersSmall className={cx(styles.container, className)}>
      <GridCol className="fe_u_fill--height">{children}</GridCol>
    </GridRow>
  );
};

export default Container;
